<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4><i class="fas fa-history"></i> Histórico de {{ title }}</h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        :title="`Voltar para aba de ${title}`"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div class="col-md-6 mb-3" v-for="item in itens" :key="item.id">
            <div class="card border" v-if="item.data">
                <div class="card-header bg-gray">
                    <p><b>Data</b> {{ item.data }}</p>
                    <p><b>Técnico</b> {{ item.tecnico }}</p>
                </div>
                <div class="card-body">
                    <p>
                        <b>Ano/Série que frequenta?</b>
                        {{
                            verificarResposta(
                                item.ano_serie_frequentou,
                                $root.arrays.ano_serie
                            )
                        }}
                    </p>
                    <p>
                        <b>Concluiu o curso?</b>
                        {{ pergunta(item.concluiu_curso) }}
                    </p>
                    <p>
                        <b>Série escolar/colegial/superior</b>
                        {{
                            verificarResposta(
                                item.curso_frequenta,
                                $root.arrays.curso_frequenta
                            )
                        }}
                    </p>
                    <p>
                        <b>Curso mais elevado que frequentou</b>
                        {{
                            verificarResposta(
                                item.curso_frequentou,
                                $root.arrays.curso_frequentou
                            )
                        }}
                    </p>
                    <p>
                        <b>Código INEP da escola</b>
                        {{ item.escola_inep }}
                    </p>
                    <p>
                        <b>A escola é localizada no município?</b>
                        {{ pergunta(item.escola_localizada_municipio) }}
                    </p>
                    <p>
                        <b>Município onde está localizada a escola</b>
                        {{ item.escola_municipio }}
                    </p>
                    <p>
                        <b>Estado onde está localizada a escola</b>
                        {{ item.escola_uf }}
                    </p>
                    <p>
                        <b>Nome da escola</b>
                        {{ item.escola_nome }}
                    </p>
                    <p>
                        <b>Frequentou escola?</b>
                        {{
                            verificarResposta(
                                item.frequenta_escola,
                                $root.arrays.frequenta_escola
                            )
                        }}
                    </p>
                    <p>
                        <b>Sabe Ler e Escrever?</b>
                        {{ pergunta(item.sabe_ler) }}
                    </p>
                </div>
            </div>
            <div v-else>
                <div v-if="itens.length <= 1">
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Não possui histórico ainda.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Historico",
    props: ["id", "tipo", "title"],
    data() {
        return {
            loading: true,
            itens: {},
        };
    },
    mounted() {
        this.getItens();
    },
    methods: {
        getItens() {
            axios
                .get(`api/dashboard/usuarios/historico/${this.tipo}/${this.id}`)
                .then((response) => {
                    this.itens = response.data;
                    this.loading = false;
                });
        },
        replace(string, search, change) {
            return string.replaceAll(search, change);
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            if (resposta) {
                const result = array.filter((item) => item.id == resposta);
                return result[0] ? result[0].value : "";
            } else {
                return "";
            }
        },
    },
};
</script>
